import React from 'react';
import dayjs from 'dayjs';
import { Popconfirm, Space, Avatar } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPen } from '@fortawesome/free-solid-svg-icons';

import styles from './Usuarios.module.less';

const relativeTime = require('dayjs/plugin/relativeTime');

dayjs.extend(relativeTime);

const imagePath = 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/User-avatar.svg/2048px-User-avatar.svg.png';

const columnsDevices = (t, currentUser, deleteDevice, editDevice, viewDevice) => [
  {
    title: t('tables.users.columns.first_name'),
    width: '30%',
    dataIndex: 'full_name',
    fixed: 'left',
    align: 'left',
    render: (_, record) => (
      // eslint-disable-next-line react/jsx-filename-extension
      <div>
        <Avatar
          src={record.image ? record.image : imagePath}
          style={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            marginRight: 10,
            background: '#eae4e4',
          }}
        />
        {` ${record.first_name} ${record.last_name}`}
      </div>
    ),
  },
  {
    width: '20%',
    title: t('tables.users.columns.mail'),
    dataIndex: 'email',
    align: 'left',
    render: (email) => email || '-',
  },
  {
    width: '10%',
    title: t('tables.users.columns.rol'),
    dataIndex: 'role',
    align: 'left',
    render: (role) => role || '-',
  },
  {
    width: '10%',
    title: t('tables.users.columns.information'),
    render: (_, record) => ( // view datails
      // eslint-disable-next-line react/jsx-filename-extension
      <div
        onClick={() => viewDevice(record)}
        onKeyDown={() => viewDevice(record)}
        role="link"
        tabIndex={0}
      >
        <span
          style={{
            color: '#828282',
            borderBottom: '1px solid #828282',
            cursor: 'pointer',
          }}
        >
          {t('tables.users.columns.view')}
        </span>
      </div>
    ),
  },
  {
    key: 'has_missing_data_alarm_rule',
    width: '15%',
    title: '',
    dataIndex: 'id',
    render: (_, record) => ( // edit users
      // eslint-disable-next-line react/jsx-filename-extension
      <Space>
        <div className={styles.btnsIcon} style={{ marginRight: 5 }}>
          <FontAwesomeIcon icon={faPen} onClick={() => editDevice(record)} />
        </div>

        {(currentUser.id !== record.id) && (
          <div className={styles.btnsIcon} style={{ marginLeft: 5 }}>
            <Popconfirm
              title={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_title')}
              okText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_ok')}
              cancelText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_cancel')}
              onConfirm={() => deleteDevice(record)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Popconfirm>
          </div>
        ) }
      </Space>
    ),
  },
];

export default columnsDevices;
